import React, { FunctionComponent, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import GameProvider from "../game-provider";
import { GameInfoNav, Spinner } from "../components";
import { NotFoundView } from "./not-found";
import ApiService from "../services/api-services";
import { GameCodes } from "../type";
import {
  useTranslator,
  useTranslationReducer,
} from "../context/TranslationContext";

export const SettingView: FunctionComponent = () => {
  const { gameCode: rawGameCode = "" } = useParams();
  const [gameCode, setGameCode] = useState<GameCodes>(GameCodes.Unknown);
  const [setting, setSetting] = useState<Record<string, unknown>>();
  const [notFound, setNotFound] = useState(false);
  const translationReducer = useTranslationReducer();
  const translator = useTranslator();

  useEffect(() => {
    const gameCode = GameProvider.convertGameCode(
      rawGameCode || GameCodes.Unknown
    );
    setGameCode(gameCode);
    if (gameCode !== GameCodes.Unknown)
      ApiService.getSetting(gameCode)
        .then((res) => {
          if (res.ok && res.data) {
            setSetting(res.data);
          } else {
            setNotFound(true);
          }
        })
        .catch((e) => {
          console.error(e);
          setNotFound(true);
        });
  }, [rawGameCode]);

  useEffect(() => {
    translationReducer();
  }, []);
  if (!gameCode || gameCode === GameCodes.Unknown || notFound)
    return <NotFoundView />;

  if (!setting) return <Spinner />;

  const title = translator.getGameName(gameCode);
  const settingComponent = GameProvider.getGameSettingView(gameCode);

  document.title = `${title} - Settings`;
  return (
    <>
      <GameInfoNav gameCode={rawGameCode} />
      <div className="px-3 pt-2">
        <div>
          <h3>{title}</h3>
        </div>
        <hr />
        <div className="card">
          <div className="card-header">Setting</div>
          <div className={`card-body ${gameCode}`}>
            {React.createElement(settingComponent, {
              key: "setting-component",
              data: setting,
            })}
          </div>
        </div>
      </div>
    </>
  );
};
